import { getChainId } from '../lib'

export default (data, resourceName) => {
    if (resourceName === 'employees' || resourceName === '_employees') {
        // Rede limpa no select chega como null (o defaultParse do react-admin troca '' por null);
        // o backend recusa chainId null ("Rede não definida"), então vale a rede da barra.
        if (data.chainId === undefined || data.chainId === null || data.chainId === '') {
            data.chainId = getChainId()
        }
    }
    return data
}
